import roomac from "../assets/images/roomac.svg";
import roomairpurifier from "../assets/images/roomairpurifier.svg";
import roombalcony from "../assets/images/roombalcony.svg";
import roombathtub from "../assets/images/roombathtub.svg";
import roombed from "../assets/images/roombed.svg";
import roomcouplefriendly from "../assets/images/roomcouplefriendly.svg";
import roomdining from "../assets/images/roomdining.svg";
import roomheater from "../assets/images/roomheater.svg";
import roomkettle from "../assets/images/roomkettle.svg";
import roomminibar from "../assets/images/roomminibar.svg";
import roomshower from "../assets/images/roomshower.svg";
import roomsmoking from "../assets/images/roomsmoking.svg";
import roomtv from "../assets/images/roomtv.svg";

export const RoomAmenityIcons = {
  AC: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomac}
      alt="roomac"
    />
  ),
  Shower: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomshower}
      alt="roomshower"
    />
  ),
  Smoking: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomsmoking}
      alt="roomsmoking"
    />
  ),
  TV: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomtv}
      alt="roomsmoking"
    />
  ),
  "Bath Tub": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombathtub}
      alt="roomsmoking"
    />
  ),
  "Air purifier": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomairpurifier}
      alt="roomsmoking"
    />
  ),
  "Electric Kettle": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomkettle}
      alt="roomsmoking"
    />
  ),
  "In room Dining": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomdining}
      alt="roomsmoking"
    />
  ),
  Minibar: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomminibar}
      alt="roomsmoking"
    />
  ),
  Heater: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomheater}
      alt="roomsmoking"
    />
  ),
  "King Size": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombed}
      alt="roomsmoking"
    />
  ),
  "Queen Size": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombed}
      alt="roomsmoking"
    />
  ),
  Balcony: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombalcony}
      alt="roomsmoking"
    />
  ),
  "Bunk Beds": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombed}
      alt="roomsmoking"
    />
  ),
  "Twin Beds": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={
        "https://ik.imagekit.io/hotelzifyprod/New%20Amenity/Property%201=Bed_BhaypuAW0w.png?updatedAt=1692803295593"
      }
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(351deg) brightness(93%) contrast(86%)",
      }}
      alt="roomsmoking"
    />
  ),
  "Full bed": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={
        "https://ik.imagekit.io/hotelzifyprod/New%20Amenity/Property%201=Bed_BhaypuAW0w.png?updatedAt=1692803295593"
      }
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(351deg) brightness(93%) contrast(86%)",
      }}
      alt="roomsmoking"
    />
  ),
  "Couple Friendly": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomcouplefriendly}
      alt="roomsmoking"
    />
  ),
  Fridge: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/fridge.svg"}
      alt="fridge"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Hair Dryer": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/hair%20dryer.svg"}
      alt="Hair Dryer"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Microwave: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/microwave.svg"}
      alt="Microwave"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Iron: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/iron.svg"}
      alt="Iron"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Ironing Board": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/iron_board.svg"}
      alt="Ironing Board"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
};
